export default "__VITE_ASSET__7Tm8W9b9__"